var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var GiftBoxSvg = /* @__PURE__ */ __name(function GiftBoxSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M66,34.4H6a3,3,0,0,1-3-3V23.08a3,3,0,0,1,3-3H37.43c2,.06,3.81.11,6.33,0H66a3,3,0,0,1,2.12.88A3,3,0,0,1,69,23.08V31.4A3,3,0,0,1,66,34.4Zm-59-4H65V24.08H43.85c-2.58.12-4.48.06-6.48,0H7Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M63.16,68.86H7.64a3,3,0,0,1-3-3V32.31h4V64.86H62.16V32.34h4V65.86A3,3,0,0,1,63.16,68.86Z"
  }), /* @__PURE__ */ React.createElement("rect", {
    x: "29.36",
    y: "22.08",
    width: "3",
    height: "43.03"
  }), /* @__PURE__ */ React.createElement("rect", {
    x: "38.31",
    y: "22.14",
    width: "3",
    height: "43.03"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M40.62,23.82,40,20.9a13.42,13.42,0,0,0,9.52-7.32,4.9,4.9,0,0,0,.24-3.78,3.57,3.57,0,0,0-1.85-2.18c-2.67-1.21-5.54-.07-8.52,3.36-2.81,3.23-2.46,8.22-2,10.91l0,.17-3,.46,0-.12c-.54-3.22-.92-9.23,2.69-13.39,4.93-5.67,9.26-5.37,12-4.12a6.54,6.54,0,0,1,3.45,3.93A8,8,0,0,1,52.13,15,16.41,16.41,0,0,1,40.62,23.82Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M30.06,23.82A16.39,16.39,0,0,1,18.55,15a7.91,7.91,0,0,1-.42-6.15,6.54,6.54,0,0,1,3.45-3.93c2.76-1.25,7.09-1.55,12,4.12,3.62,4.16,3.24,10.17,2.69,13.39l0,.12-3-.46,0-.17c.46-2.69.81-7.68-2-10.91-3-3.44-5.86-4.57-8.53-3.36A3.59,3.59,0,0,0,21,9.8a4.85,4.85,0,0,0,.24,3.78,13.4,13.4,0,0,0,9.52,7.32Z"
  }));
}, "GiftBoxSvg");
var GiftBoxIcon = /* @__PURE__ */ __name(function GiftBoxIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: GiftBoxSvg
  }, props));
}, "GiftBoxIcon");
export {
  GiftBoxIcon
};
